import React from "react";
import ActionListHeaderSheet from "../../sheet/ActionListHeaderSheet";

const SellerHeaderSheet = props => {
    const { values, handleAction } = props;
    const actions = [
        {
            title: "Supprimer",
            type: "remove"
        }
    ];

    return (
        <div className="headerSheet">
            <div className="infos">
                <p className={"titleSheet alone"}>{values.fullname}</p>
            </div>
            <ActionListHeaderSheet actions={ actions } handleAction={ handleAction } />
        </div>
    );
}

export default SellerHeaderSheet;
